import { LTText } from '@lambdatestincprivate/lt-components';
import { TrustFooter } from './TrustFooter';
import styles from './landing.module.css';

/**
 * The shared shell for the pre-open screens (Landing + the opening/unpack
 * screen): a single no-scroll viewport with a centered heading + primary
 * action (drop zone / URL form, or the unpack card) and the trust notes
 * pinned to the bottom as a footer. `dim` fades the surrounding chrome back
 * while a file is dragged over the window, keeping focus on the drop target.
 */
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function EvidenceIntro(_ref) {
  var children = _ref.children,
    _ref$dim = _ref.dim,
    dim = _ref$dim === void 0 ? false : _ref$dim;
  var dimCls = dim ? styles.dimmed : '';
  return /*#__PURE__*/_jsxs("div", {
    className: styles.openingWrap,
    children: [/*#__PURE__*/_jsx("div", {
      className: styles.openingMain,
      children: /*#__PURE__*/_jsxs("div", {
        className: styles.openingContent,
        children: [/*#__PURE__*/_jsxs("div", {
          className: "".concat(styles.head, " ").concat(dimCls),
          children: [/*#__PURE__*/_jsx(LTText, {
            as: "h1",
            text: "Open a test run\u2019s evidence",
            color: "var(--lt-text-primary)",
            className: styles.title,
            style: {
              fontSize: '28px',
              lineHeight: '36px',
              fontWeight: 600
            }
          }), /*#__PURE__*/_jsx(LTText, {
            as: "p",
            text: "Replay every step, screenshot, log and AI root cause from a Kane AI test run.",
            variant: LTText.TextVariant.BODY_REGULAR,
            color: "var(--lt-text-secondary)",
            className: styles.subtitle
          })]
        }), children]
      })
    }), /*#__PURE__*/_jsx(TrustFooter, {
      dim: dim
    })]
  });
}